import React, {useRef} from "react";
import { Column } from "@ant-design/plots";
import { Card } from "antd";
import { FiFileText } from "react-icons/fi";

const TeamWiseColumnGraph = ({ teamWiseExperience, buId, selectTeam }) => {
  const chartDataTransformed = teamWiseExperience.flatMap((item) => [
    {
      Department: item.team,
      Experience: parseFloat(item.highestExperience, 0),
      type: "Highest Experience",
    },
    {
      Department: item.team,
      Experience: parseFloat(item.averageExperience, 0),
      type: "Average Experience",
    },
  ]);

  const chartRef = useRef(null);
    const rotatelabel = (datum, ranking, name) => {
      const { chart } = chartRef.current;
      const { document } = chart.getContext().canvas;
  
      const group = document?.createElement("g", {});
  
      const text =
        name[ranking].length > 10
          ? `${name[ranking].substring(0, 8)}...`
          : name[ranking];
  
      const label = document.createElement("text", {
        style: {
          text,
          fontSize: 12,
          fill: "#9B9DA0",
          textAlign: "center",
  
          transform: `translate(0, 25) rotate(-45deg)`,
        },
      });
  
      group.appendChild(label);
      return group;
    };

  const config = {
    data: chartDataTransformed,
    isGroup: true,
    xField: "Department",
    yField: "Experience",
    seriesField: "type",
    colorField: "type",
    legend: {
      color: {
        title: false,
        position: "bottom",
        rowPadding: 5,
        layout: {
          margin: 10,
        },
      },
    },
    axis: {
      x: { size: 40,
          labelFormatter: (datum, index,text) => rotatelabel(datum, index,text),
          grid:true,
          gridLineWidth:2,
         
          },
          
      y: { grid:true, gridLineWidth:2},
    },
    height: 300,
    scale: {
      x: { padding: 0.5 },
    },
    onReady: ({ chart }) => {
      chartRef.current = { chart };
    },
  };

  return (
    <Card style={{ border: "1px solid #0000001F", borderRadius: "16px" }}>
      <div
        style={{
          fontWeight: "700",
          fontSize: "16px",
          padding: "0px 8px 4px 8px",
        }}
      >
        {(selectTeam || buId) === "SPAN-BLR-0001" ? "BU All Experience" : " Team Wise Experience"}
      </div>
      {teamWiseExperience.length == 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "305px",
            color: "#9B9DA0",
            fontWeight: "700",
          }}
        >
          <span><FiFileText style={{ fontSize: "60px" }} /></span>
          <span>No data available</span>
        </div>
      ) : (
        <Column {...config} />
      )}
    </Card>
  );
};

export default TeamWiseColumnGraph;
